module.exports = __webpack_public_path__ + "img/avatar.04c5d6b5.png";